(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-to-top"] && !Shopify.designMode) return;
  try {
    (() => {
    const button = document.getElementById('click-to-top');
    if (!button) return;
    let pending = false;
    const update = () => {
      button.hidden = Math.max(0, window.scrollY) <= 100;
      pending = false;
    };
    window.addEventListener('scroll', () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(update);
    }, { passive: true });
    button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'instant' }));
    update();
  })();
  } catch(e) { console.error(e); }
})();

})();
